/** @jsx jsx */
import { jsx } from 'theme-ui'
import React from 'react'
import { BillboardProps } from './types'

const Billboard: React.FC<BillboardProps> = ({
  breadcrumbs,
  primaryContent,
  primarySlot,
  fullWidthSlot,
  bgImage,
  mobileImage,
  showImageOnMobile = false,
}) => {
  const styles = () => {
    if (primarySlot) {
      return 'modules.billboard.primaryContent'
    }

    return `modules.billboard.${
      fullWidthSlot ? 'contentWithFullWidthSlot' : 'contentWithoutFullWidthSlot'
    }`
  }

  return (
    <div>
      <div sx={{ variant: 'modules.billboard.container' }}>
        <div
          sx={{
            display: 'flex',
            flexDirection: 'column',
            paddingBottom: fullWidthSlot ? ['0', 'xs'] : '0',
            variant: 'modules.billboard.wrapper',
          }}
        >
          <If condition={breadcrumbs}>
            <div
              sx={{
                variant:
                  !primarySlot && bgImage
                    ? 'modules.billboard.breadcrumbsWithImage'
                    : 'modules.billboard.breadcrumbs',
              }}
            >
              {React.cloneElement(breadcrumbs, { variant: 'billboard' })}
            </div>
          </If>

          <If condition={mobileImage}>
            <div
              sx={{
                width: ['100%', '404px', '404px'],
                height: ['0', '255px', '416px'],
                margin: ['30px auto', '30px auto', '0'],
                paddingTop: ['35%', '0', '0'],
                display: ['block', 'block', 'none'],
                backgroundImage: `url(${mobileImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'contain',
                variant: 'modules.billboard.bgImagePosition',
              }}
            />
          </If>

          <If condition={!bgImage}>
            <div sx={{ variant: 'modules.billboard.primaryContainer' }} />
          </If>

          <div
            sx={{
              marginBottom: fullWidthSlot
                ? ['lg', primarySlot ? 'xxl' : 'lg']
                : !primarySlot && bgImage && showImageOnMobile
                ? 0
                : !primarySlot && bgImage && !showImageOnMobile
                ? ['xl', 'xxl', '0']
                : ['xl', 'xxl'],
              display: 'flex',
              height: ['auto', 'auto', 'auto'],
              minHeight: !primarySlot && bgImage ? [undefined, undefined, '416px'] : undefined,
              flexDirection: ['column', 'column', 'row'],
              justifyContent: ['center', 'center', 'space-between'],
              position: 'relative',
              alignItems: ['flex-end', 'center'],
            }}
          >
            <div
              sx={{
                alignSelf: 'center',
                textAlign: primarySlot || bgImage ? 'left' : 'center',
                variant: styles(),
                marginX: primarySlot || bgImage ? ['0', 'auto', '0'] : 'auto',
                width: ['auto', '70%', '50%'],
                'ul > li': { fontSize: ['sm', 'md'], paddingY: 10 },
              }}
            >
              {primaryContent}
            </div>

            <If condition={primarySlot}>
              <div
                sx={{
                  variant: 'modules.billboard.primarySlot',
                  width: ['100%', '70%', '40%'],
                  marginTop: ['0', 'lg', '0'],
                  marginX: ['auto', 'auto', '0'],
                }}
              >
                {React.cloneElement(primarySlot, { variant: 'billboard' })}
              </div>
            </If>

            <If condition={!primarySlot && bgImage}>
              <div
                sx={{
                  width: ['90%', '404px', '404px'],
                  height: ['0', '255px', '416px'],
                  position: ['static', 'static', 'absolute'],
                  bottom: 0,
                  right: 0,
                  margin: ['30px auto 0', '30px auto 0', '0'],
                  paddingTop: ['60%', '0', '0'],
                  display: [
                    showImageOnMobile && !mobileImage ? 'block' : 'none',
                    showImageOnMobile && !mobileImage ? 'block' : 'none',
                    'block',
                  ],
                  backgroundImage: [`url(${mobileImage || bgImage})`, `url(${bgImage})`],
                  backgroundRepeat: 'no-repeat',
                  backgroundSize: 'contain',
                  variant: 'modules.billboard.bgImagePosition',
                }}
              />
            </If>
          </div>

          <If condition={fullWidthSlot}>
            <div
              sx={{
                width: ['100%', '70%', '100%'],
                marginX: ['0', 'auto', '0'],
                variant: 'modules.billboard.fullWidthSlot',
              }}
            >
              {fullWidthSlot}
            </div>
          </If>
        </div>
      </div>
    </div>
  )
}
export default Billboard
